/**
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
**/
import './currency-formator-behaviour.js';

window.corpBehaviours = window.corpBehaviours || {};
corpBehaviours.appCommonBehaviourChild = {
    properties: {
        dateFormat: {
            type: String
        },
        userId: {
            type: String
        },
        corpId: {
            type: String
        },
        //to support multi lnaguages
        locale: String
    },
    ready: function () {
        this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
        this.locale = clientStorage.get(storageType.session, 'lang');
        var tempAmountFormat = clientStorage.get(storageType.session, 'amountFormat');
        if (tempAmountFormat == "Lakh Format") {
            this.amountFormat = "en-IN";
        } else {
            this.amountFormat = "en-US";
        }
        this.userId = clientStorage.get(storageType.session, 'userId');
        this.corpId = clientStorage.get(storageType.session, 'corpId');
    },
    formatCurrency: function (amt, sym) {
        if (!_.isNil(amt) && sym) {
            return this._symbolizeCurrency(sym + ' ' + amt);
        }
        return '';
    },
    formatAmountWithoutCurrency: function (amt) {
        if (!_.isNil(amt)) {
			this.homeCurrency = clientStorage.get(storageType.session, 'homeCurrency');
            return this._symbolizeCurrency(this.homeCurrency + ' ' + amt);
        }
        return '';
    },    
    formatAddress: function (obj) {
        var str = '';
        if (obj) {
            str += !_.get(obj, 'address') ? '' : _.get(obj, 'address');
            str += (str ? ", " : "") + (!_.get(obj, 'addressLine1') ? '' : _.get(obj, 'addressLine1'));
            str += (str ? ", " : "") + (!_.get(obj, 'addressLine2') ? '' : _.get(obj, 'addressLine2'));
            str += (str ? ", " : "") + (!_.get(obj, 'city') ? '' : _.get(obj, 'city'));
            str += (str ? ", " : "") + (_.isString(obj.state) ? _.get(obj, 'state') :
                (!_.get(obj, 'state.stateDescription') ? '' : _.get(obj, 'state.stateDescription')));
            str += (str ? ", " : "") + (!_.get(obj, 'zipCode') ? '' : _.get(obj, 'zipCode'));
            str += (str ? ", " : "") + (_.isString(obj.country) ? _.get(obj, 'country') :
                (!_.get(obj, 'country.codeDescription') ? '' : _.get(obj, 'country.codeDescription')));
        }
        return str;
    },
    maskedAccount: function (accountId, codeType) {
        return accountId ? maskAccount.accountFormat(accountId, codeType) : '';
    },
    formatDate: function (date) {
		var res = moment.utc(date);
		res = moment(res.toDate()).format(clientStorage.get(storageType.session, 'dateFormat'));
		return res;
	},
    displayLiteral: function (lit) {
        return getLabel(lit);
    },
    checkEquality: function (value1, value2) {
        if (value1 == value2)
            return true;
        else
            return false;
    },
    logicalAnd: function (value1, value2) {
        if (value1 && value2)
            return true;
        return false;
    },
    //added to handle timestamp issue for dates displayed in UI components as a part of 326179 fix
    formatTemplateDate: function (date) {
        var formatedDate = setBusinessToDateString(date);
        if (!this.dateFormat)
            this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
        return OEUtils.DateUtils.format(formatedDate, this.dateFormat);
    },
    _convertDate: function (date) {
        var formatedDate = setBusinessToDateString(date);
        if (!this.dateFormat)
            this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
        return OEUtils.DateUtils.format(formatedDate, this.dateFormat);
    },
    formatYesNoValues: function (value) {
      if(value == "Y" || value == "N"){
            if (value == "Y") {
         return getLabel('b_yestxt');
        }
        else return getLabel('b_notxt');
      }
    },
    _getChannelContextMessage: function (chennelContext, multiple = false, messageKey = 0, messageType = "") {
        if (chennelContext) {
            var message = chennelContext.status.message;
            if (multiple) {
                var subTitleList = [];
                if (message && message.length) {
                    if (messageType) {
                        var filteredMessage = message.filter(item => item.message_TYPE == messageType);
                        if (filteredMessage && filteredMessage.length) {
                            subTitleList = filteredMessage.map(item => {
                                if (item.hasOwnProperty("messageDesc")) {
                                    return item.messageDesc;
                                }
                            });
                        }
                        return subTitleList;
                    }

                    subTitleList = message.map(item => {
                        if (item.hasOwnProperty("messageDesc")) {
                            return item.messageDesc;
                        }
                    });
                    return subTitleList;
                }
            } else {
                if (message && message[messageKey]) {
                    return message[messageKey].messageDesc;
                }
                return message[0].messageDesc;
            }
        }
    },
    _getChannelContext(e) {
        if (e.detail.__data && e.detail.__data.hasOwnProperty("xhr") && e.detail.__data.xhr.getResponseHeader('channelcontext')) {
            var chennelContext = JSON.parse(e.detail.__data.xhr.getResponseHeader('channelcontext'));
            return chennelContext;
        }
    },
    _saveAsTemplateFunction: function () {
        if (this.isPayFromTemplateListing) {
            this.createTabsDivId = "templates_overview_tab_section";
            this.createTabsIronPageId = "template_overview_tab_iron_pages";
        } else if (this.isPayFromBillersListing) {
            this.createTabsDivId = "corp_registered_billers_tab_section";
            this.createTabsIronPageId = "corp_registered_billers_tab_iron_pages";
        }
        else if(this.fromScheduledTransaction == true){
            this.createTabsDivId = "corporate_approval_landing_tab_section";
            this.createTabsIronPageId = "corporate_approval_landing_tab_iron_pages";
        }
        else if (this.flowSelected == 'DRAFTPAYMENT') {
            this.createTabsDivId = "corporate_approval_landing_tab_section";
            this.createTabsIronPageId = "corporate_approval_landing_tab_iron_pages";
        }
        else if(window.location.pathname == "/corp-add-vendor-landing"){
            this.createTabsDivId = "corp_add_vendor_tab_section";
            this.createTabsIronPageId = "corp_add_vendor_tab_iron_pages";
        }
        else if (window.location.pathname == "/corp-complete-tracking-status") {
            this.createTabsDivId = "corporate_fileUpload_landing_tab_section";
            this.createTabsIronPageId = "corporate_fileUpload_landing_tab_iron_pages";
        }
        
        else if(window.location.pathname == "/counterparty-management"){
            this.createTabsDivId = "counterparty_overview_tab_section";
            this.createTabsIronPageId = "counterparty_overview_tab_iron_pages";
        }
        else {
            this.createTabsDivId = "payment_overview_tab_section";
            this.createTabsIronPageId = "payment_overview_tab_iron_pages";
        }

        this.createTabUniqueIdentifier = ['saveAsTemplateTab'];
        var refId = '';
        var resObj = JSON.parse(JSON.stringify(this.responseObject));
        console.log('==debitAccountName', this.debitAccountName);
        resObj.bodyEntryDetails = this.body.entryDetails
        if (_.get(resObj, 'commonSection')) {
            refId = String(resObj.commonSection.requestReferenceId || resObj.commonSection.transactionReferenceId);
        }

        this.createTab(getLabel('l_SaveAsTemplate'), "corp-save-as-template", {
            "saveAsTemplateTab": "saveAsTemplate" + refId,
            transactionTypes: [{
                transactionTypeDescription: resObj.transactionType.codeDescription,
                transactionType: resObj.transactionType.cmCode
            }],
            transactionCurrency: resObj.transactionCurrency.cmCode,
            transactionObject: resObj,
            isSaveAsTemplate: true,
            selectedTempSavePage: 0,
            debitAccountName: this.debitAccountName ? this.debitAccountName : resObj.entryDetails[0].initiatorAccount 
        });
    },
    _isListData(items) {
        return (items && items.length) ? true : false;
    },
    _isEqualTo(value, type) {
        return value == type;
    },
    chargesCalculationBeh(txnCurrency, totalCha) {
        var vatp = clientStorage.get(storageType.session, 'corpVATPercent');
        var vatPV = 1 + (vatp / "100");
        var charge = totalCha.toString() / vatPV;
        var vat = charge * (vatp / 100);
        var curr = txnCurrency ? txnCurrency : clientStorage.get(storageType.session, 'homeCurrency')
        // var curr = clientStorage.get(storageType.session, 'homeCurrency')
        return currency.symbolize(curr + " " + charge);
        //return parseFloat(charge).toFixed(3);
    },
    vatCalculationBeh(txnCurrency, totalCha) {
        var vatp = clientStorage.get(storageType.session, 'corpVATPercent');
        var vatPV = 1 + (vatp / 100);
        var charge = totalCha.toString() / vatPV;
        var vat = charge * (vatp / 100);
        var curr = txnCurrency ? txnCurrency : clientStorage.get(storageType.session, 'homeCurrency')
        // var curr = clientStorage.get(storageType.session, 'homeCurrency')
        return currency.symbolize(curr + " " + vat);
        //return parseFloat(vat).toFixed(3);
    },
    truncateDigits(value, decimalPlace) {
        value = value.toString();
        return value.slice(0, (value.indexOf('.') + decimalPlace))
    },
    _formatPipedAmount(amtValue) {
    var formatAmt = "";
    if (amtValue && amtValue.indexOf("|") != -1) {
      var amtArr = amtValue.split("|");
      if (amtArr && amtArr[0] == "" && amtArr[1] == 0) {
        formatAmt = "";
      }
      if (
        amtArr &&
        amtArr[0] != undefined &&
        amtArr[0] != "" &&
        amtArr[1] != undefined
      ) {
        formatAmt =(amtArr[0] + " " + Number(amtArr[1]).toFixed(3));
        formatAmt = this._symbolizeCurrency(formatAmt)
      }
    }
    return formatAmt;
  }
};
corpBehaviours.appCommonBehaviour = [corpBehaviours.appCommonBehaviourChild, sbBehaviours.currencyFormatorBehaviour];